<template>
  <div v-if="mfa && mfaStep !== 0 && mfaStep !== 9" class="mfa-auth" :style="siteStyles">
      <!-- <div v-if="mfaStep === 0" class="mfa-loader">
        <v-progress-linear color="#40A8CB" :indeterminate="true"></v-progress-linear>
      </div> -->
      <div v-if="mfaStep === 4" class="phone-extra">
        <h2>
          Hey
          <span class="username">{{ user.username }}</span>, we need to verify your phone number to get started.
        </h2>
          <v-container class="pa-0 my-4">
            <v-layout row wrap>
              <v-flex xs3 class="pr-2">
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12>
                    <div class="Input__inputLabel___nQolz">Method</div>
                    <v-select hide-details v-model="verifyChoice" :items="choices" solo></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs8 class="phone-container pa-0">
                <v-layout class="full-phone" row wrap justify-center align-center>
                  <v-flex xs12>
                    <div class="Input__inputLabel___nQolz">Phone Number</div>
                  </v-flex>
                  <v-flex xs4>
                    <v-select
                      :color="appButtonColor"
                      class="country-list mr-2"
                      solo
                      hide-details
                      v-model="adminCountry"
                      :items="countries"
                      item-text="label"
                      item-value="value"
                    ></v-select>
                  </v-flex>
                  <v-flex xs8>
                    <v-text-field
                      :color="appButtonColor"
                      hide-details
                      v-model="adminPhone"
                      type="text"
                      name="phone"
                      solo
                      placeholder="Phone Number"
                      :mask="phoneMask"
                      class="phone-text"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="mt-3">
                <v-layout row wrap justify-center align-center>
                  <v-flex xs12>
                    <v-btn :color="appButtonColor" :loading="phoneLoading" class="form-submit ma-0" @click="sendPhoneDetails">Submit</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        <v-flex xs12>
          <div v-if="mfaErrorMessage" class="migrationError mt-3">{{ mfaErrorMessage }}</div>
        </v-flex>
      </div>
      <div v-else>
        <div class="main-blue" v-if="mfaStep === 1 || mfaStep === 10">
          Hello
          <!-- <span>{{ userData.username }}</span>, we need to verify your {{ verifyChoice === 'email' ? 'email' : 'phone number' }} to get started. -->
          <p class="welcome-text">For your security, we need to verify it's really you. We will send a verification code to the following:</p>
        </div>
        <div class="main-blue" v-if="mfaStep === 3">
          Hi
          <span class="username">{{ userData.username }}</span>, please enter the code from your authentication app to continue.
        </div>
        <v-form @submit.prevent>
          <v-container class="pa-0">
            <v-layout row wrap v-if="mfaStep === 1">
              <v-flex xs12 sm6>
                <!-- <div class="Input__inputLabel___nQolz">Method</div> -->
                <p class="welcome-text bold-shark">Send the code via:</p>
                <v-radio-group v-model="verifyChoice" class="auth-choices">
                  <v-radio
                    v-for="item in filteredChoices"
                    color="#212529"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></v-radio>
                </v-radio-group>
                <!-- <v-select v-model="verifyChoice" :items="filteredChoices" solo></v-select> -->
              </v-flex>
              <v-flex xs12 sm4 v-if="verifyChoice === 'sms' || verifyChoice === 'voice'">
                <p class="welcome-text bold-shark">Phone number ending in:</p>
                <v-select
                  v-model="phoneChoice"
                  :items="phones"
                  solo
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 v-else-if="verifyChoice === 'email'">
                <p class="welcome-text bold-shark">Email:</p>
                <v-text-field
                  solo
                  v-model="emailMask"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="mfaStep === 10">
              <v-flex xs12 sm6>
                <!-- <div class="Input__inputLabel___nQolz">Method</div> -->
                <p class="welcome-text bold-shark">Send the code via:</p>
                <v-radio-group v-model="verifyChoice" class="auth-choices">
                  <v-radio
                    v-for="item in choices"
                    color="#212529"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></v-radio>
                </v-radio-group>
                <!-- <v-select v-model="verifyChoice" :items="filteredChoices" solo></v-select> -->
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="mfaStep === 2 || mfaStep === 6 || mfaStep === 7">
              <v-flex xs12>
                <div class="main-blue">Enter verification code</div>
                <p class="welcome-text">
                  <span v-if="deliveryMethod !== ''">
                  <v-icon color="#cd493c">warning</v-icon>
                  </span>Please enter the verification code you 
                  received<span v-if="deliveryMethod !== ''"> via {{deliveryMethodText}}</span>.
                  <span v-if="!deliveryMethod"><a @click="checkChallenge('resend')">Resend Code</a></span>
                </p>
                <v-flex xs12 sm4>
                  <v-text-field
                    solo
                    autofocus
                    v-model="mfaAnswer"
                    placeholder="Please enter code"
                    required
                    @keyup.enter="checkChallenge"
                  ></v-text-field>
                </v-flex>
                
                <div v-if="mfaError" class="migrationError mt-3">{{ mfaErrorMessage }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="mfaStep === 3">
              <v-flex xs12>
                <div class="Input__inputLabel___nQolz">Code</div>
                <v-text-field
                  solo
                  autofocus
                  v-model="mfaAnswer"
                  placeholder="Please enter code"
                  required
                  @keyup.enter="checkChallenge"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="mfaStep === 8">
              <v-flex xs12>
                <h1 v-if="!mfaError" class="mb-3">
                  Please answer the following
                  {{ this.questions.Questions.length > 1 ? this.questions.Questions.length : "" }}
                  question{{ this.questions.Questions.length > 1 ? "s" : "" }}
                  to help us verify your identity
                </h1>
                <div v-if="!mfaError" class="mb-3" v-for="question in this.questions.Questions">
                  <v-radio-group :label="question.Text.Statement" v-model="question.answer" class="auth-choices">
                    <span v-if="question.HelpText" class="caption mb-2">{{ question.HelpText.Statement }}</span>
                    <v-radio
                      v-for="item in question.Choices"
                      color="#212529"
                      :key="item.ChoiceId"
                      :label="item.Text.Statement"
                      :value="item.ChoiceId"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div v-if="mfaError" class="migrationError mt-3">{{ mfaErrorMessage }}</div>
              </v-flex>
            </v-layout>
            <div class="mfa-submit" v-if="mfaStep === 1 || mfaStep === 10">
              <p class="welcome-text mt-0">Need help? Call us at <a v-if="!mersBranded" href="tel:+1-833-325-3787">833.325.3787</a><a v-else href="tel:+1-800-767-6377">800.767.6377</a></p>
              <div class="submit-right">
                <v-btn
                :color="appButtonColor"
                class="form-submit ma-0 load-button mr-3 inverse"
                @click="logout"
                >Back</v-btn>
                <v-btn
                :color="appButtonColor"
                class="form-submit ma-0 load-button"
                @click="checkChallenge"
                :loading="sendLoading"
                >Send Code</v-btn>
              </div>
            </div>
            <v-flex v-else>
              <v-flex v-if="mfaStep !== 8 && mfaStep !== 10">
                <v-checkbox
                  v-model="rememberDevice"
                  label="Remember this device. Do not check this box if you are using a public computer."
                  :color="appButtonColor"
                  hide-details
                ></v-checkbox>
              </v-flex>
              <div class="mfa-submit">
                <p class="welcome-text">
                  <div class="submit-right">
                    <v-btn
                    :color="appButtonColor"
                    class="form-submit ma-0 load-button mr-3 inverse"
                    @click="logout"
                    >Back</v-btn>
                    <v-btn
                    :color="appButtonColor"
                    class="form-submit ma-0 load-button"
                    @click="checkChallenge"
                    :loading="sendLoading"
                    >Submit</v-btn>
                  </div>
                </p>
              </div>
            </v-flex>
          </v-container>
        </v-form>
      </div>
  </div>
  <div v-else-if="!awsMfa" v-bind:class="amplifyUI.formSection" class="login-form">

    <div v-if="mersBranded" class="my-2 subheading">Looking for your MERS Defined Benefit Plan account information? 
      It's now available at <a href="https://mersofmich.com">mersofmich.com</a>.</div>

    <div v-bind:class="amplifyUI.sectionHeader">
      {{options.header}}
      <p
        v-if="!mersBranded"
        class="welcome-text"
      >Is this your first visit? 
      <a 
        v-bind:class="amplifyUI.a"
        v-on:click="signUp">Set up online access
      </a>
      </p>
      <p class="welcome-text"><strong>Security Reminder</strong>: Alerus will never ask for your password or a one-time pass code by text, phone, or email. If someone requests this information, <strong>DO NOT RESPOND</strong>.</p>
    </div>
    <div v-bind:class="amplifyUI.sectionBody">
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Username')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="options.username"
          :placeholder="$Amplify.I18n.get('Enter your username')"
          autofocus
          aria-label="username"
          v-on:keyup.enter="signIn"
          name="username"
          id="username"
        />
        <div v-bind:class="amplifyUI.hint" v-if="!mersBranded">
          <a
            v-bind:class="amplifyUI.a"
            v-on:click="forgotUsername"
          >{{$Amplify.I18n.get('Forgot username')}}</a>
        </div>
        <div v-bind:class="amplifyUI.hint" v-else>
          <a
            v-bind:class="amplifyUI.a"
            v-on:click="forgotUsername"
          >{{$Amplify.I18n.get('Forgot username?')}}</a>
        </div>
      </div>
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Password')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="password"
          type="password"
          name="password"
          id="password"
          aria-label="password"
          :placeholder="$Amplify.I18n.get('Enter your password')"
          v-on:keyup.enter="signIn"
        />
        <div v-bind:class="amplifyUI.hint" v-if="!mersBranded">
          <a
            v-bind:class="amplifyUI.a"
            v-on:click="forgot"
          >{{$Amplify.I18n.get('Forgot password')}}</a>
        </div>
        <div v-bind:class="amplifyUI.hint" v-else>
          <a
            v-bind:class="amplifyUI.a"
            v-on:click="forgot"
          >{{$Amplify.I18n.get('Forgot password?')}}</a>
        </div>
      </div>
    </div>
    <div v-bind:class="sectionFooter">
      <span v-bind:class="sectionFooterPrimary">
        <v-btn
          v-bind:class="amplifyUI.button"
          v-on:click="signIn"
          :loading="buttonLoad"
          dark
          depressed
          :color="appButtonColor"
          large
          class="ma-0 load-button dark-btn"
        >{{$Amplify.I18n.get(mersBranded ? 'Log In' : 'Log In')}}</v-btn>
      </span>
      <span
        v-bind:class="amplifyUI.sectionFooterSecondaryContent"
        v-if="options.isSignUpDisplayed && mersBranded"
      >
        <p>OR</p>
        <v-btn
          v-bind:class="amplifyUI.button"
          v-on:click="signUp"
          dark
          depressed
          :color="appButtonColor"
          large
          class="ma-0 load-button"
        >{{$Amplify.I18n.get('Create myMERS Account')}}</v-btn>
        <div class="mers-text">
          Employers: If you need assistance creating your account,
          <br />please contact our Service Center at
          <a href="tel:800-767-6377">800-767-6377</a>.
        </div>
      </span>
    </div>
    <div class="error" v-if="error">{{ error }}</div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" scrollable width="600px" persistent>
        <v-card>
          <v-card-text class="pa-0">
            <privacy />
          </v-card-text>
          <v-card-actions>
            <v-btn :color="appButtonColor" @click="printMe">Print</v-btn>
            <v-spacer></v-spacer>
            <v-btn :color="appButtonColor" @click="getAnswer(false)">Decline</v-btn>
            <v-btn :color="appButtonColor" @click="getAnswer(true)">Accept</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
  <confirm-sign-in v-else></confirm-sign-in>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import * as AmplifyUI from "@aws-amplify/ui";
import Privacy from "@/components/Privacy.vue";
import { mapState } from "vuex";
import VueHtmlToPaper from "@/plugins/print";
import ConfirmSignIn from "@/components/ConfirmSignIn.vue";
import countries from "aws-amplify-vue/src/assets/countries";
import { isInteger } from 'lodash';
import { API } from "aws-amplify";

export default {
  name: "SignIn",
  props: ["signInConfig"],
  mixins: [VueHtmlToPaper],
  components: {
    Privacy,
    ConfirmSignIn,
  },
  created() {
    if (this.mfa && this.user) {
      if (this.user.challengeName === "SOFTWARE_TOKEN_MFA") {
        this.challenge(true)
      }
      else if (this.user.challengeName === "CUSTOM_CHALLENGE") {
        this.challenge()
      }
    }
  },
  data() {
    return {
      password: "",
      emptyPhone: false,
      currentStep: 1,
      digit1: "",
      digit2: "",
      digit3: "",
      digit4: "",
      digit5: "",
      digit6: "",
      countries,
      adminCountry: "1",
      phoneLoading: false,
      adminPhone: "",
      rememberDevice: false,
      error: "",
      amplifyUI: AmplifyUI,
      logger: {},
      dialog: false,
      userResponse: true,
      terms: false,
      buttonLoad: false,
      deliveryMethod: "",
      questions: {},
      allChoices: [
        {
          text: "Text message",
          value: "sms"
        },
        {
          text: "Phone call",
          value: "voice"
        },
        {
          text: "Email",
          value: "email"
        },
        {
          text: "Authenticator application",
          value: "totp"
        }
      ],
      choices: [
        {
          text: "Text message",
          value: "sms"
        },
        {
          text: "Phone call",
          value: "voice"
        }
      ],
      noTotpchoices: [
        {
          text: "Text message",
          value: "sms"
        },
        {
          text: "Phone call",
          value: "voice"
        },
        {
          text: "Email",
          value: "email"
        },
      ],
      phoneChoice: "",
      deviceChoice: "",
      verifyChoice: "sms",
      userData: "",
      loading: false,
      backLoading: false,
      sendLoading: false,
      mfaError: false,
      mfaErrorMessage: "",
      mfaAnswer: ""
    };
  },
  computed: {
    ...mapState("user", [
      "user",
      "retirementBranded",
      "retirementBrandedTitle",
      "mersBranded",
      "mersBrandedTitle",
      "step",
      "awsMfa",
      "mfa"
    ]),
    digitLength() {
      return `${this.digit1}${this.digit2}${this.digit3}${this.digit4}${this.digit5}${this.digit6}`.length
    },
    phoneMask() {
      if (this.adminCountry === "1") {
        return "(###) ###-####";
      } else return "##############";
    },
    emailMask() {
      if (!this.mfaEmail) return ""
      let [first, last] = this.mfaEmail.split("@")
      let [second, third] = last.split(".")
      let x = "x"
      return `${first.substring(0,1)}${x.repeat(3)}@${second.substring(0,1)}${x.repeat(3)}.${third}`
    },
    deliveryMethodText() {
      if (this.deliveryMethod === "phone") {
        if (this.verifyChoice === "voice") {
          return "Voice Call"
        } else {
          return "SMS Text"
        }
      } else {
        return "Email"
      }
    },
    mfaStep() {
      if (this.userData) {
        if (this.userData.challengeName === "SOFTWARE_TOKEN_MFA") {
          this.currentStep = 3
        }
        else if (this.userData.challengeParam) {
          if (this.userData.challengeParam.extraNeeded === "true") {
            this.currentStep = 4
          }
          else if (this.userData.challengeParam.question) {
            this.currentStep = 5
          }
          else if (this.userData.challengeParam.request_id) {
            if (this.userData.challengeParam.type && this.userData.challengeParam.type === 'risk_otp_send') {
              this.currentStep = 7
            } else if (this.userData.challengeParam.type && this.userData.challengeParam.type === 'risk_quiz_questions') {
              this.currentStep = 8
              this.questions = JSON.parse(this.userData.challengeParam.questions)
              this.questions = this.questions.QuestionSet
            } else {
              if (this.userData.challengeParam.delivery_method === 'phone') {
                this.deliveryMethod = this.userData.challengeParam.delivery_method
                this.currentStep = 10
              } else if (this.userData.challengeParam.delivery_method === 'email') {
                this.deliveryMethod = this.userData.challengeParam.delivery_method
                this.currentStep = 11
              } else {
                this.currentStep = 6
              }
            }
          } else if (this.userData.challengeParam.type) {
            if (this.userData.challengeParam.type === 'fraud_check_failure') {
              this.currentStep = 9
            }
          }
          else {
            let step = this.userData.challengeParam.stage ? Number(this.userData.challengeParam.stage) : 0
            this.currentStep = step
          }
        }
        return this.currentStep
      }
      else return this.currentStep
    },
    phones() {
      if (this.userData) {
        if (this.userData.challengeParam.defaultMfa) {
          this.verifyChoice = this.userData.challengeParam.defaultMfa
        }
        if (this.userData.challengeParam.phones) {
          let parse = JSON.parse(this.userData.challengeParam.phones)
          if (!parse.length) {
            this.emptyPhone = true
            return []
          }
          parse.sort((a, b) => { return a.updatedAt > b.updatedAt ? -1 : 1 })
          let phones = parse.map(item => {
            if (!item.number || item.number.length < 12) return
            return {
              text: this.formatPhone(item),
              value: item.number
            }
          }).filter(item => item !== undefined)
          if (phones.length) {
            this.phoneChoice = phones[0].value
          }
          return phones
        }
        else {
          this.emptyPhone = true
          return []
        }
      }
      else {
        this.emptyPhone = true
        return []
      }
    },
    devices() {
      if (this.userData) {
        if (this.userData.challengeParam.devices) {
          let parse = JSON.parse(this.userData.challengeParam.devices)
          if (!parse.length) {
            return []
          }
          else {
            this.deviceChoice = parse[0].name
            return parse.map(item => {
              return {
                text: item.name,
                value: item.name
              }
            })
          }
        }
      }
      else {
        return []
      }
    },
    filteredChoices() {
      let choices = this.allChoices
      if (this.devices) {
        if (!this.devices.length) choices = this.noTotpchoices
      }

      if (!this.userData.challengeParam.email) {
        let index = choices.findIndex(function(choice) {
          return choice.value === 'email'
        })
        choices.splice(index, 1)
      }
      
      return choices
    },
    mfaEmail() {
      if (this.userData) {
        if (this.userData.challengeParam.email) {
          return this.userData.challengeParam.email
        }
      }
      else return ""
    },
    options() {
      const defaults = {
        header: this.retirementBranded
          ? "Access Retirement Account Access"
          : this.mersBranded
          ? "MERS Account Access"
          : "Log in to My Alerus",
        username: "",
        isSignUpDisplayed: true,
      };
      return Object.assign(defaults, this.signInConfig || {});
    },
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#CD493C";
    },
    sectionFooter() {
      if (this.mersBranded) {
        return `${AmplifyUI.sectionFooter} mers-auth`
      }
      else {
        return AmplifyUI.sectionFooter
      }
    },
    sectionFooterPrimary() {
      if (this.mersBranded) {
        return `${AmplifyUI.sectionFooterPrimaryContent} mb-0`
      }
      else {
        return AmplifyUI.sectionFooterPrimaryContent
      }
    },
    primaryColor() {
      return this.mersBranded ? "#2F6C55" : "#297994"
    },
    siteStyles() {
      return {
        '--primary-color': this.primaryColor
      }
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  methods: {
    checkEvent(event) {
      event.preventDefault()
      let val = event.target.value.split('')
      if (val.length === 6) {
        val.forEach((item,i) => {
          this[`digit${i + 1}`] = item
        })
      }
      this.$refs.digit6.focus()
    },
    onInput(event) {
      let val = event.split('')
      let top;
      val.forEach((item,i) => {
        top = i + 1
        if (i > 5) return
        else if (!isNaN(item)) this[`digit${i + 1}`] = item
      })
      if (top < 7) this.$refs[`digit${top}`].focus()
    },
    checkDigit(event, val) {
      event.preventDefault()
      if (isNaN(event.key) || this[`digit${val}`]) return
      else {
        this[`digit${val}`] = event.key
        if (val < 6) this.$refs[`digit${val + 1}`].focus()
      }
    },
    formatMfaAnswer() {
      return this.mfaAnswer
    },
    removeDigit(val) {
      this.$refs[`digit${val - 1}`].focus()
    },
    formatPhone(item) {
      let digits = item.number.length - 4;
      let lastFour = item.number.slice(-4);
      let x = "x"
      return `${lastFour}`
      // return `${x.repeat(digits)}${lastFour}`
    },
    printMe() {
      if (this.step === 1) {
        this.htmlToPaper("consent");
      } else {
        this.htmlToPaper("print");
      }
    },
    getAnswer(val) {
      if (val) {
        if (this.step === 2) {
          this.$store.commit("user/increaseStep");
          this.userResponse = true;
          this.terms = true;
          this.dialog = false;
          this.signIn();
        } else {
          this.$store.commit("user/increaseStep");
        }
      } else {
        this.userResponse = false;
        this.dialog = false;
      }
    },
    async checkChallenge(type = "default", phone, choice)  {
      let loadOn = false
      this.mfaError = false
      this.sendLoading = true
      let answer, meta;
      if (this.mfaStep === 1)  {
        this.resetDigits()
        answer = "phone_select"
        if (this.verifyChoice === "totp") {
          meta = {
            "selected_device": this.deviceChoice,
            "phone_type": this.verifyChoice,
            "mers": this.mersBranded.toString()
          }
        }
        else {
          meta = {
            "selected_phone": this.phoneChoice,
            "phone_type": this.verifyChoice,
            "email": this.mfaEmail,
            "mers": this.mersBranded.toString()
          }
        }
      }
      else if (this.mfaStep === 10) {
        answer = "phone_select"
        meta = {
          "phone_type": this.verifyChoice
        }
      }
      else if (this.mfaStep === 2) {
        if (type === "resend") {
          this.mfaErrorMessage = "Code resent."
          this.mfaError = true
          answer = "resend"
          meta = {
            "resend": "true"
          }
        }
        else {
          if (this.formatMfaAnswer().length < 6) return
          answer = this.formatMfaAnswer()
        } 
      }
      else if (this.mfaStep === 3) {
        if (this.formatMfaAnswer().length < 6) return
        try {
          this.userData = await this.$Amplify.Auth.confirmSignIn(this.userData, this.formatMfaAnswer(), "SOFTWARE_TOKEN_MFA")
          this.$store.commit("user/setState", "signedIn");
        } catch (error) {
          this.mfaErrorMessage = "Code incorrect."
          this.mfaError = true
        }
        return
      }
      else if (this.mfaStep === 4) {
        answer = phone
        meta = {
          "extraNeeded": "true",
          "selected_phone": phone,
          "phone_type": choice,
          "mers": this.mersBranded.toString()
        }
      } else if (this.mfaStep === 5) {
        // TODO
        answer = '3'
      } else if (this.mfaStep === 6 || this.mfaStep === 11) {
        answer = 'risk_challenge'
      } else if (this.mfaStep === 7) {
        if (this.formatMfaAnswer().length < 6) return
        answer = this.formatMfaAnswer()
        meta = {
          extraNeeded: 'false'
        }
      } else if (this.mfaStep === 8) {
        answer = JSON.stringify(this.questions)
      } else if (this.mfaStep === 9) {
        answer = 'fraud_check_failure'
      }

      try {
        let data = await this.$Amplify.Auth.sendCustomChallengeAnswer(this.userData, answer, meta)
        if (!data.challengeParam) {
          try {
            // remember device
            if (this.rememberDevice) {
              data.setDeviceStatusRemembered(({
                onSuccess: (val) => {
                },
                onFailure: (err) => {
                  console.log("error remembering device", err)
                }
              }))
            }
          } catch (error) {
            console.error(error)
          }
          loadOn = true
          this.$store.commit("user/setState", "signedIn");
        }
        else {
          if (this.mfaStep === 9) {
            this.$store.commit("user/setAuthError", `There was a problem validating your account. Please contact our ${this.mersBranded ? "" : "Client "}Service Center at ${this.mersBranded ? "800.767.6377" : "833.325.3787"}.`)
          }
          if (data.challengeParam.something === "pt4") {
            this.mfaErrorMessage = "Code incorrect."
            this.mfaError = true
          }
          this.userData = data
        }
      } catch (error) {
        console.log('check challenge error')
        console.error(error)
        this.mfaError = true
        if (error.message === "DefineAuthChallenge failed with error too many attempts.") {
          this.mfaErrorMessage = "Login attempts exceeded. Your account has been locked. Please contact customer support."
        } else if (error.message === "DefineAuthChallenge failed with error challenge failed.") {
          this.mfaErrorMessage = `There was a problem validating your account. Please contact our ${this.mersBranded ? "" : "Client "}Service Center at ${this.mersBranded ? "800.767.6377" : "833.325.3787"}.`
        }
        else this.mfaErrorMessage = error.message
      }
      if (!loadOn) this.sendLoading = false
    },
    async setupTOTP(user) {
      await this.$Amplify.Auth.setupTOTP(user)
    },
    async challenge(verify = false) {
      this.userData = this.user
      if (verify) return
      if (this.mfaStep === 0) {
        let ipAddress = ''
        try {
            const data = await API.get('myAlerusIdentityBroker', '/identity/getUserIP')
            ipAddress = data
        } catch (error) {
            console.error(error)
        }
        // this.userData.getCachedDeviceKeyAndPassword()
        this.userData = await this.$Amplify.Auth.sendCustomChallengeAnswer(this.userData, "device_check", {
          "deviceKey": this.userData.deviceKey,
          ipAddress
        })
      } else if (this.mfaStep === 9) {
        this.$store.commit("user/setAuthError", `There was a problem validating your account. Please contact our ${this.mersBranded ? "" : "Client "}Service Center at ${this.mersBranded ? "800.767.6377" : "833.325.3787"}.`)
      } else if (this.mfaStep === 10) {
        return
      }
      else {
        await this.checkChallenge();
      }
    },
    resetDigits() {
      this.digit1 = ""
      this.digit2 = ""
      this.digit3 = ""
      this.digit4 = ""
      this.digit5 = ""
      this.digit6 = ""
    },
    async sendPhoneDetails() {
      this.mfaErrorMessage = ""
      if (this.adminPhone.length < 10) {
        this.mfaErrorMessage = "Phone is invalid."
        return
      }
      this.phoneLoading = true
      let newPhone = `+${this.adminCountry}${this.adminPhone}`

      await this.checkChallenge("default", newPhone, this.verifyChoice)
      this.phoneLoading = false
    },
    logout() {
      this.buttonLoad = false
      this.$root.$children[0].logout()
    },
    async signIn(event) {
      if (!this.userResponse) {
        this.dialog = true;
        return;
      }
      if (!this.password) {
        this.$store.commit("user/setAuthError", "Please enter password.");
        return;
      }
      this.$store.commit("user/setAuthError", "")
      this.buttonLoad = true
      const that = this;
      let currentPassword = this.password;
      let newUsername = this.options.username.toLowerCase().trim();
      let ipAddress = ''
      try {
          const data = await API.get('myAlerusIdentityBroker', '/identity/getUserIP')
          ipAddress = data
      } catch (error) {
          console.error(error)
      }
      await this.$Amplify.Auth.signIn({
        username: newUsername,
        password: this.password,
        validationData: {
          newUsername: this.options.username.toLowerCase().trim(),
          agreedTerms: new Date().toISOString(),
          terms: `${this.terms}`,
          system: this.$route.query.system,
          ipAddress
        },
      })
        .then(async (data) => {
          console.log('signin')
          this.$store.commit("user/setAdminReset", false);
          if (
            data.challengeName === "SMS_MFA" ||
            data.challengeName === "SOFTWARE_TOKEN_MFA"
          ) {
            this.$store.commit("user/setUser", data);
            await this.challenge(true)
            this.$store.commit("user/setMfa", true)
          } else if (data.challengeName === "NEW_PASSWORD_REQUIRED") {
            AmplifyEventBus.$emit("localUser", data);
            this.$store.commit("user/setAdminReset", true);
            await this.$Amplify.Auth.completeNewPassword(data, this.password);
            this.$store.commit("user/setResetUser", data.username);
            return AmplifyEventBus.$emit("authState", "requireNewPassword");
          } else if (data.challengeName === "MFA_SETUP") {
            AmplifyEventBus.$emit("localUser", data);
            return AmplifyEventBus.$emit("authState", "setMfa");
          } else if (data.challengeName === "CUSTOM_CHALLENGE") {
            this.$store.commit("user/setUser", data)
            await this.challenge()
            this.$store.commit("user/setMfa", true)
          }
           else {
            return AmplifyEventBus.$emit("authState", "signedIn");
          }
        })
        .catch((e) => {
          // this.setError(e);
          if (
            e.message ===
            "PreAuthentication failed with error please accept new terms."
          ) {
            this.dialog = true;
            this.password = currentPassword;
          } else if (e.message === "Password reset required for the user") {
            this.$store.commit("user/setResetUser", this.options.username);
          }
        });
        this.buttonLoad = false
    },
    forgot: function () {
      AmplifyEventBus.$emit("authState", "forgotPassword");
      this.$router.push("/resetpassword");
    },
    forgotUsername: function () {
      this.$router.push("/forgotusername")
    },
    signUp: function () {
      AmplifyEventBus.$emit("authState", "signUp");
      this.$router.push("/signup");
    },
    setError: function (e) {
      console.log(e)
      this.$store.commit("user/setAuthError", this.$Amplify.I18n.get(e.message || e))
      // this.logger.error(this.error);
    },
  }
};
</script>

<style lang="scss">
.mfa-input {
  .v-input__slot {
    padding: .75rem !important;
    min-height: auto !important;
    border: 1px solid #aaa !important;
  }
  .v-text-field--outline > .v-input__control > .v-input__slot {
    background: #f4f5f8 !important;
  }
  input {
    margin: 0;
    width: 20px;
    text-align: center;
    padding: 0;
    color: #212529;
    font-weight: bold;
    &:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 60px #f4f5f8 inset !important;
      box-shadow: 0 0 0 60px #f4f5f8 inset !important;
      background-color: #f4f5f8 !important;
      background-clip: content-box !important;
    }
  }
  .shrink {
    width: min-content;
  }
}
.bold-shark {
  font-weight: 600 !important;
}
.mfa-submit {
  p {
    a {
      text-decoration: none;
    }
  }
  .welcome-text {
    border-bottom: 1px solid #ddd;
    padding-bottom: 2rem;
  }
  .submit-right {
    display: flex;
    justify-content: flex-end;
    .v-btn__content {
      font-size: 16px;
    }
    .inverse {
      background-color: #fff !important;
      border: 1px solid #cd493c !important;
      box-shadow: none;
      .v-btn__content {
        color: #212529;
      }
    }
  }
}
.auth-choices {
  margin: 0;
  padding: 0;
  .v-label {
    font-size: 1.25rem;
    color: #212529;
  }
}
.mfa-auth {
  .v-input--checkbox {
    .v-input__slot{
      align-items: initial;
    }
    label {
      font-size: 1rem;
      color: #3a3a3a;
    }
  }
  .welcome-text a {
    color: var(--primary-color) !important;
  }
  .migrationError {
    color: #cd493c;
    font-size: 14px;
  }
}
.mers-auth {
  .v-btn__content {
    text-transform: initial !important;
  }
}
.phone-extra {
  .v-select__selections{
    padding-top: 0 !important;
  }
}
// .phone-container {
//   .v-text-field__details {
//     padding: 0 12px;
//     margin-bottom: 8px !important;
//   }
// }
.full-phone {
  .v-text-field__slot {
    input {
      margin-top: 0;
      max-height: initial;
    }
  }
}
.text-decoration-underline {
  text-decoration: underline;
}
// .country-list {
//   .v-select__selections {
//     input {
//       display: none;
//     }
//   }
// }
</style>

<style lang="scss" scoped>
.login-form input {
  border: 1px solid lightgray;
}
// .welcome-text {
//   font-size: 1.25rem;
//   margin-top: 0.5rem;
//   font-weight: initial;
//   a {
//     color: #41a8ca;
//     font-weight: 600;
//   }
// }
.Section__sectionFooter___1T54C {
  border-top: 1px solid #ddd;
  padding-top: 1.5rem;
}
.Section__sectionFooterPrimaryContent___2r9ZX {
  button {
    background-color: #cd493b !important;
    .v-btn__content{
      font-size: 1rem;
    }
  }
}
.mers {
  .welcome-text {
    font-size: 0.95rem;
  }
  .inverse {
    border: 1px solid #33715a !important;
  }
  .mers-text {
    // color: #314452;
    margin-top: 1rem;
    font-size: 0.9rem;
  }
  .mers-auth {
    display: flex;
    flex-wrap: wrap;
    span {
      width: 100%;
      text-align: center;
    }
    button {
      background-color: #fff !important;
      color: #33715a;
      border: 1px solid;
      width: initial;
      font-size: 1rem;
      min-width: 176px;
    }
    .dark-btn {
      background-color: #33715a !important;
      color: #fff;
      // border: none;
    }
    p {
      font-size: .9rem;
      margin: 1.25rem auto;
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    p:before,
    p:after {
      content: '';
      border-top: 1px solid;
      margin: 0 20px 0 0;
      flex: 1 0 20px;
    }
    p:after {
      margin: 0 0 0 20px;
    }
  }
}
.load-button {
  border-radius: 3px !important;
}
.mfa-auth {
  margin: 0 auto;
  max-width: 800px;
  a {
    color: #0B2A4A;
  }
  span.username {
    color: #40a7c7;
  }
  h2 {
    font-size: 1.25rem;
    font-weight: initial;
    margin-top: 0.5rem;
  }
  .mfa-loader {
    width: 50%;
    margin: 0 auto;
  }
  button {
    text-transform: capitalize;
    color: #fff;
    background-color: #0B2A4A;
    &:active {
      background-color: #0B2A4A;
    }
    &:focus {
      outline: none;
    }
  }
  .error {
    margin-top: 1.5rem;
    color: #fd0000;
  }
  .mers {
  .v-dialog {
    button {
      border-radius: 4px;
    }
    a {
      color: #33715a;
    }
    button {
      background-color: #33715a !important;
      &:active {
        background-color: #33715a !important;
      }
    }
  }
  }
}
</style>